import { FunctionComponent, useMemo } from 'react';
import { IconSummary } from '../IconSummary';
import { MapMarkerAltLightIcon } from '../../../Icons';
import { DeliveryMethod } from '@shared/types';
import { PublicCourse, PublicOccurrence } from '@cademy-package/sdk-component-types';

const CLASSES_WITH_LOCATIONS: DeliveryMethod[] = ['in-person', 'hybrid'];

export type LocationProps = {
    course: PublicCourse;
    occurrence?: PublicOccurrence | null;
};

export const Location: FunctionComponent<LocationProps> = ({ occurrence, course }) => {
    const courseAddress = useMemo(() => {
        if ('address' in course) {
            return course.address;
        }
    }, [course]);

    if (
        !occurrence ||
        !occurrence.delivery ||
        !CLASSES_WITH_LOCATIONS.includes(occurrence.delivery)
    ) {
        return null;
    }

    if (occurrence.delivery && !CLASSES_WITH_LOCATIONS.includes(occurrence.delivery)) {
        return null;
    }

    const itemAddress = occurrence.address ? occurrence.address : courseAddress;

    if (!itemAddress) {
        return null;
    }

    const formattedAddress = Object.values(itemAddress)
        .filter((addressLine) => addressLine !== null)
        .join(', ');

    return <IconSummary Icon={MapMarkerAltLightIcon}>{formattedAddress}</IconSummary>;
};
